import * as React from 'react'
import * as PropTypes from 'prop-types'
import {SearchToSelect, Selector} from "../../../components";
import * as api from '../api'

export class TrackedTopicSetSelector extends React.Component{

  static propTypes = {
    requireSelection: PropTypes.bool,
    accountId: PropTypes.string,
    onSelected: PropTypes.func.isRequired,
    selected: PropTypes.any // a tracked topic set
  }

  static defaultProps = {

  }

  cache = {}

  fetchAllForAccountId() {
    const {accountId, requireSelection} = this.props;
    if (!(accountId in this.cache)) {
      this.cache[accountId] = api.getTrackedTopicSets({ accountId })
        .catch(ex => {
          delete this.cache[accountId];
          throw ex
        })
    }
    return this.cache[accountId]
  }

  getSearchResults = ({ query, offset,...rest }) => {
    const {accountId, requireSelection} = this.props;
    return this.fetchAllForAccountId()
      .then(topicSets => {
        if (this.props.requireSelection && !this.props.selected && topicSets.length) {
          this.props.multi ? this.props.onSelected([topicSets[0]]) : this.props.onSelected(topicSets[0])
        }
        const matching = topicSets.filter(x => !query || x.name.toLowerCase().startsWith(query.trim().toLowerCase()));
        return (requireSelection || !!query ? [] : [null]).concat(matching)
      })
  }

  resolveSelection = (ids) => {
    const idSet = new Set(ids);
    return this.fetchAllForAccountId().then(xs => xs.filter(x => idSet.has(x._id)));
  }

  render() {
    const {accountId, eager, requireSelection, required, ...rest} = this.props
    return <SearchToSelect
      key={accountId}
      getSearchResults={this.getSearchResults}
      eager={eager || requireSelection}
      renderOption={x => x ? x.name : 'All Topics'}
      placeholder={<span className="text-muted">{this.props.requireSelection ? 'Select a topic' : 'All Topics'}</span>}
      getKey={x => !x || x._id}
      required={required || requireSelection}
      resolveSelection={rest.selectByKey ? this.resolveSelection : undefined}
      {...rest}
    />
  }
}


